import {
  Accordion,
  Button,
  Divider,
  Grid,
  Group,
  Radio,
  RadioGroup,
  Text,
  Title,
} from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { useState } from 'react';
import { Minus, Plus } from 'tabler-icons-react';
import { defaultSettlementValue } from '../../../../data/onboard-form-initival-values.object';
import { MerchantOnboardingFormValues } from '../../../../type/merchant-onboarding-form-values.types';
import Settlement from './settlement.component';

interface Props {
  form: UseFormReturnType<MerchantOnboardingFormValues>;
}
function SettlementDetails(props: Props) {
  const { form } = props;
  const MIN_BANKS = 1;
  const MAX_BANKS = 2;
  const [numSettlement, setNumSettlement] = useState(MIN_BANKS);

  const label = {
    isWantPackworksWallet: 'Would you like to open a Packworks wallet?',
    isWantPayMayaBankWallet: 'Would you like to open a Maya Bank Account?',
    isWantMayaWallet: 'Would you like to open a Maya wallet?',
  };

  const settlements = form.values.settlements.map((settlement, index) => {
    return (
      <Accordion.Item key={index} label={'Settlement ' + (index + 1)} opened>
        <Settlement index={index} form={form} />
      </Accordion.Item>
    );
  });

  return (
    <>
      <Grid>
        <Grid.Col>
          <Title order={3} style={{ fontWeight: 600 }}>
            Settlement Details
          </Title>
          <Text size='xs' color='grey'>
            You are automatically eligible for a Packworks and Maya bank account
          </Text>
        </Grid.Col>

        <Grid.Col>
          <Accordion multiple initialItem={0} data-cy='settlementsAccordion'>
            {settlements}
          </Accordion>
        </Grid.Col>
        {form.errors && (
          <Grid.Col>
            {settlements?.map((value, index) => {
              return (
                <div key={index}>
                  {JSON.stringify(form.errors).includes(
                    'settlements.' + index.toString()
                  ) && (
                    <Text color='red'>
                      Invalid field/s in settlements {index + 1}
                    </Text>
                  )}
                </div>
              );
            })}
          </Grid.Col>
        )}
        <Grid.Col xs={12} md={6}>
          <Button
            data-cy='addSettlementButton'
            fullWidth
            onClick={() => {
              form.addListItem('settlements', defaultSettlementValue);
              setNumSettlement((prev) => {
                return prev + 1;
              });
            }}
            variant='outline'
            color='dark'
            disabled={numSettlement >= MAX_BANKS}
          >
            <Group noWrap>
              <Plus
                size={15}
                strokeWidth={2}
                color={numSettlement >= MAX_BANKS ? '#adb5bd' : 'black'}
              />
              ADD SETTLEMENT
            </Group>
          </Button>
        </Grid.Col>
        <Grid.Col xs={12} md={6}>
          <Button
            data-cy='removeSettlementButton'
            fullWidth
            onClick={() => {
              form.removeListItem(
                'settlements',
                form.values.settlements!.length - 1
              );
              setNumSettlement((prev) => {
                return prev - 1;
              });
            }}
            disabled={numSettlement <= MIN_BANKS}
            variant='outline'
            color='dark'
          >
            <Group noWrap>
              <Minus
                size={15}
                strokeWidth={2}
                color={numSettlement <= MIN_BANKS ? '#adb5bd' : 'black'}
              />
              REMOVE SETTLEMENT
            </Group>
          </Button>
        </Grid.Col>

        <Grid.Col>
          <RadioGroup
            label={label.isWantPackworksWallet}
            sx={{ '& label': { fontSize: 14 } }}
            onChange={(value: string) => {
              form.setFieldValue('isWantPackworksWallet', value === 'true');
            }}
            value={form.values.isWantPackworksWallet.toString()}
            data-cy='isWantPackworksWallet'
          >
            <Radio value='true' label='Yes' />
            <Radio value='false' label='No' />
          </RadioGroup>
        </Grid.Col>
        <Grid.Col>
          <RadioGroup
            label={label.isWantPayMayaBankWallet}
            sx={{ '& label': { fontSize: 14 } }}
            onChange={(value: string) => {
              form.setFieldValue('isWantPayMayaBankAccount', value === 'true');
            }}
            value={form.values.isWantPayMayaBankAccount.toString()}
            data-cy='isWantPayMayaBankAccount'
          >
            <Radio value='true' label='Yes' />
            <Radio value='false' label='No' />
          </RadioGroup>
        </Grid.Col>
        <Grid.Col>
          <RadioGroup
            label={label.isWantMayaWallet}
            sx={{ '& label': { fontSize: 14 } }}
            onChange={(value: string) => {
              form.setFieldValue('isWantPayMayaBankWallet', value === 'true');
            }}
            value={form.values.isWantPayMayaBankWallet.toString()}
            data-cy='isWantPayMayaBankWallet'
          >
            <Radio value='true' label='Yes' />
            <Radio value='false' label='No' />
          </RadioGroup>
        </Grid.Col>
        <Grid.Col>
          <Divider my='md' />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default SettlementDetails;
